var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 30,
    height: 20,
    rx: 3.76698,
    stroke: "#0B6BDD",
    strokeWidth: 2.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.0002L13.3333 15.0002",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.668 25H30.0013",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.0999C22.1539 16.0999 23.9004 17.8463 23.9004 20.0002C23.9004 22.1542 22.1539 23.9006 20 23.9006C17.8461 23.9006 16.0996 22.1542 16.0996 20.0002C16.0996 17.8463 17.8461 16.0999 20 16.0999Z",
    stroke: "#0B6BDD",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.f0420af8cddb8817d497a776521f47d9.svg";
export { ForwardRef as ReactComponent };